import React, { FC } from "react";
import { ChatMessageDTO, ChatVariant, MessageVariant } from "src/store/messenger";
import cn from "classnames";
import { SystemMessageItem } from "../system-message-item";
import { RegularMessageItem } from "../regular-message-item";
import s from "./styles.module.scss";

type Props = {
  message: ChatMessageDTO;
  chatVariant?: ChatVariant;
  shouldShowAvatar: boolean;
  shouldShowCorner: boolean;
  isOutgoingMessage: boolean;
  isLastItem: boolean;
};

const MessageItem: FC<Props> = ({
  message,
  chatVariant,
  shouldShowAvatar,
  shouldShowCorner,
  isOutgoingMessage,
  isLastItem,
}) => {
  const isGroupChat = chatVariant === ChatVariant.GROUP;

  const isSystemMessage = message.type === MessageVariant.SYSTEM;

  const renderMessageItem = () => {
    switch (true) {
      case isSystemMessage:
        return <SystemMessageItem message={message} key={message.id} />;
      default:
        return (
          <RegularMessageItem
            message={message}
            key={message.id}
            shouldShowAvatar={shouldShowAvatar}
            shouldShowCorner={shouldShowCorner}
            isOutgoingMessage={isOutgoingMessage}
            shouldShowCaption={isGroupChat}
            isGroupChat={isGroupChat}
          />
        );
    }
  };

  return (
    <div className={cn(s.cloud_wrap, { [s.bottomPadded]: isLastItem })}>
      {renderMessageItem()}
    </div>
  );
};

export default MessageItem;
